// import { css } from "@/theme";
import { SVGProps, useMemo } from "react";

// TODO would like to get an ease animation working
// const styles = {
//   svg: css`
//     @keyframes easeInOutSine {
//       0% { animation-timing-function: cubic-bezier(0.445, 0.05, 0.55, 0.95); }
//       100% { animation-timing-function: cubic-bezier(0.445, 0.05, 0.55, 0.95); }
//     }

//     polyline {
//       /* transition: all 0.3s ease; */
//       animation-timing-function: cubic-bezier(0.445, 0.05, 0.55, 0.95);
//     }
//   `
// };

export type SvgChartProps = {
  data: number[];
  // width of the SVG canvas
  width: number;
  // height of the SVG canvas
  height: number;
  // padding around the graph
  // padding?: number | [number, number];
  // color?: string;
} & SVGProps<SVGSVGElement>;

// const DEMO = [50, 45, 40, 35, 30, 25, 20, 15, 10, 5, 10, 15, 20, 25, 30, 35, 40, 35, 30, 25, 25, 25, 25];

export const SvgChart = ({ data, width, height, ...props }: SvgChartProps) => {
  // const px = typeof padding === "number" ? padding : padding[0];
  // const py = typeof padding === "number" ? padding : padding[1];
  // don't allow max of 0
  // data = DEMO;
  const maxValue = Math.max(...data, 1);
  const xScaleFactor = width / (data.length - 1); // scale factor for the x-axis (1-hour intervals)
  const yScaleFactor = height / maxValue; // scale factor for the y-axis (values 0-50)

  // TODO maybe use setState as we can then animate if the data changes
  const initialPoints = useMemo(() => data.map((_, i) => {
    const x = i * xScaleFactor; // + px;
    const y = height; // + py;
    return `${x},${y}`;
  }).join(" "), [data, xScaleFactor, height]);

  const points = useMemo(() => data.map((value, i) => {
    const x = i * xScaleFactor; // + px
    const y = height - (value * yScaleFactor); // + py
    return `${x},${y}`;
  }).join(" "), [data, xScaleFactor, yScaleFactor, height]);

  const viewbox = useMemo(() => `0 0 ${width} ${height}`, [width, height]);

  return (
    <svg id="graph" {...props} width={width} height={height} viewBox={viewbox}>
      <polyline fill="none" stroke="currentColor" strokeWidth="3" points={initialPoints}>
        <animate
          attributeName="points"
          from={initialPoints}
          to={points}
          dur="0.3s"
          fill="freeze"
        // easing="easeInOutSine"
        />
      </polyline>
    </svg>
  );
};
